import { availabilityLabel, type Availability } from '@/catalog/selectors'
import { Badge, type BadgeTone } from '@/components/ui/Badge'

const tones: Record<Availability, BadgeTone> = {
  playable: 'volt',
  'coming-soon': 'sky',
  unavailable: 'flare',
  'no-build': 'neutral',
}

export function AvailabilityBadge({ availability, className }: { availability: Availability; className?: string }) {
  return (
    <Badge tone={tones[availability]} className={className}>
      {availability === 'playable' && <span className="size-1.5 rounded-full bg-current" aria-hidden="true" />}
      {availabilityLabel[availability]}
    </Badge>
  )
}
